<template>
  <router-view />
</template>
<script lang="ts" setup>
import { onBeforeMount } from "vue";
// import setting from "@/config/default/setting.config";
var img = new Image();
img.src = "./favicon.ico"; // 替换为你的图片路径
img.height = 16; // 设置图片大小，小于标题字体大小
img.width = 16;
onBeforeMount(() => {
  document.title = "四川大学研工系统服务大厅";
});
</script>
<style lang="scss"></style>
